import { render, staticRenderFns } from "./fixeauDefault.vue?vue&type=template&id=5b15fd62&scoped=true&"
import script from "./fixeauDefault.vue?vue&type=script&lang=js&"
export * from "./fixeauDefault.vue?vue&type=script&lang=js&"
import style0 from "./fixeauDefault.vue?vue&type=style&index=0&id=5b15fd62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15fd62",
  null
  
)

export default component.exports